//import React from 'react'
//import { Outlet, Link, NavLink, useAsyncError } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

//import Artwork from './artwork.js'
//import { contains } from 'jquery';
//import { useActionState } from 'react';
//import PhotoViewer from './photoViewer.js'

export default function PhotoViewer({name, onClose, onNextClick, onPrevClick}) {

    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    function reOpen(selector) {
    
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        var dataName = selector.closest('.window').getAttribute('data-name');
        //console.log(selector)
        //console.log(selector.nodeName)
        //console.log(dataName)
        //console.log('PV')

        if (dataName === 'Photo Viewer') {
            clearActiveWindow();
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            return;
        }

        //if (selector.nodeName !== 'BUTTON' && (selector.classList.contains('toolbar-button') || selector.parentElement.classList.contains('toolbar-button'))) return;
        if (selector.nodeName === 'BUTTON' && (selector.classList.contains('form-minimise') || selector.classList.contains('form-close'))) return;
        
        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        // document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';

    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    return (
        <>

        <div className="window active" data-name="Photo Viewer" onClick={reOpen}>

            <div className="title-bar">
                <div className="title-bar-text">{name}</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="Photo Viewer"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="Photo Viewer"></button>
                </div>
            </div>

            <div className="window-body">
                <img src={"/images/gallery2/" + name} alt="image gallery photo"></img>
            </div>
            
            <div className="navigation">
                <div className="toolbar-compound-button-wrapper">
                    <button className="toolbar-button lightweight back-button" onClick={onPrevClick}>
                        <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                    </button>
                </div>
                <div className="toolbar-compound-button-wrapper">
                    <button className="toolbar-button lightweight forward-button" onClick={onNextClick}>
                        <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                    </button>
                </div>
            </div>

        </div>

        </> 
    )
}